import * as CONST from "./actionTypes";

const intialState = {
  driversListData: [],
  driverDataView: null,
  total: 0,
  loading: false,
};

const driversReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    //get data
    case CONST.GET_DRIVERS:
      return {
        ...state,
        loading: true,
      };

    case CONST.GET_DRIVERS_SUCCESS:
      return {
        ...state,
        driversListData: payload?.data,
        total: payload.totalcount,
        loading: false,
      };

    case CONST.GET_DRIVERS_FAIL:
      return {
        ...state,
        loading: false,
      };

    case CONST.UPDATE_DRIVERS_LIST:
      return {
        ...state,
        driversListData: payload,
      };

    // get service by id

    case CONST.GET_DRIVER_VIEW:
      return {
        ...state,
        loading: true,
      };

    case CONST.GET_DRIVER_VIEW_SUCCESS:
      return {
        ...state,
        driverDataView: payload,
        loading: false,
      };

    case CONST.GET_DRIVER_VIEW_FAIL:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;

      break;
  }
};

export default driversReducer;
